import { cn } from "@/lib/utils";

const STEP_BUTTON =
  "flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-pill border border-waves-line bg-white text-lg font-bold text-waves-ink transition-colors hover:bg-waves-mist focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-40";

// −/value/+ control, as used for "Aantal posities".
export function Stepper({
  value,
  onChange,
  min = 0,
  max = Number.POSITIVE_INFINITY,
  className,
  "aria-label": ariaLabel,
}: {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  className?: string;
  "aria-label"?: string;
}) {
  return (
    <div role="group" aria-label={ariaLabel} className={cn("flex items-center gap-2", className)}>
      <button type="button" className={STEP_BUTTON} disabled={value <= min} onClick={() => onChange(Math.max(min, value - 1))} aria-label="Minder">
        −
      </button>
      <output className="flex h-[42px] flex-1 items-center justify-center rounded-pill border border-waves-line font-mono text-base font-semibold text-waves-ink">
        {value}
      </output>
      <button type="button" className={STEP_BUTTON} disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))} aria-label="Meer">
        +
      </button>
    </div>
  );
}
